// extracted by mini-css-extract-plugin
export var imglyTypoButton = "style-module--imgly--typo-button--h0Pha";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--sGHA2";
export var imglyTypoH1 = "style-module--imgly--typo-h1--bu3Cu";
export var imglyTypoH2 = "style-module--imgly--typo-h2--lEiZD";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--YyZkp";
export var imglyTypoH3 = "style-module--imgly--typo-h3--tkD0S";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--zvcXS";
export var imglyTypoH4 = "style-module--imgly--typo-h4--MG3u6";
export var imglyTypoH5 = "style-module--imgly--typo-h5--lrB9d";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--RFAp-";
export var imglyTypoIcon = "style-module--imgly--typo-icon--1db94";
export var imglyTypoLink = "style-module--imgly--typo-link--Bzeoa";
export var imglyTypoOverline = "style-module--imgly--typo-overline--fIbo4";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--698e2";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--JoAfk";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--rjd8N";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--dLQh+";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--FmYZp";
export var imglyTypoSubline = "style-module--imgly--typo-subline--6nRuk";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--fG0lT";
export var naviLabelIsLarge = "style-module--navi-label-is-large--D9Hkn";
export var naviLabelIsSmall = "style-module--navi-label-is-small--zbNmj";
export var root = "style-module--root--mN2Fa";